import { Location } from 'react-router-dom';
import { route } from "../../constants/routes";
const regexUUID =
  /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

const truncateText = (
  text: string | null | undefined, 
  options: {
    defaultText: string;
    xsLimit?: number;
    sLimit?: number;
  }
): string => {
  if (!text) return options.defaultText;
  
  const { xsLimit = 15, sLimit = 30 } = options;
  
  const isXs = window.innerWidth <= 320;
  const isS = window.innerWidth <= 375;
  
  if (isXs && text.length > xsLimit) {
    return text.substring(0, xsLimit) + '...';
  }
  
  if (isS && text.length > sLimit) {
    return text.substring(0, sLimit) + '...';
  }
  
  return text;
};

const GetSelected = (location: Location<any>): string => {
  const path = location.pathname;

  if (path.includes(route("/profile"))) {
    return route("/profile");
  }

  if (path === route("/dashboard")) {
    return route("/dashboard");
  }

  if (path === route("/company") || 
      path === route("/company/clients") || 
      path === route("/company/users") || 
      path === route("/company/candidates")) {
    return route("/company");
  }

  if (path === route("/client-profile")) {
    return route("/client-profile");
  }

  if (path.includes(route("/client-profile/"))) {
    const sliced = path.split('/');
    const id = sliced[sliced.length - 1];

    if (regexUUID.test(id)) {
      return route(`/client-profile/${id}`);
    }
  }

  if (path === route("/stage-screen")) {
    return route("/stage-screen");
  }

  if (path === route("/stage-screen")) {
    return route("/stage-screen");
  }

  if (path.includes(route("/stage-screen/"))) {
    const sliced = path.split('/');

    const last = sliced[sliced.length - 1];
    const secondLast = sliced[sliced.length - 2];

    if (regexUUID.test(last) && regexUUID.test(secondLast)) {
      return route(`/client-profile/${secondLast}/stage-screen/${last}`);
    }

    if (regexUUID.test(last)) {
      return route(`/client-profile/${last}/stage-screen`);
    }
  }

  if (path === route("/users")) {
    return route("/users");
  }

  if (path === route("/user-profile")) {
    return route("/user-profile");
  }

  if (path.includes(route("/user-profile/"))) {
    const sliced = path.split('/');
    const id = sliced[sliced.length - 1];

    if (regexUUID.test(id)) {
      return route(`/user-profile/${id}`);
    }
  }

  if (path === route("/candidates")) {
    return route("/candidates");
  }

  if (path === route("/candidate-match")) {
    return route("/candidate-match");
  }

  if (path === route("/site-recommendations")) {
    return route("/site-recommendations");
  }

  if (path === route("/candidate-profile")) {
    return route("/candidate-profile");
  }

  if (path.includes(route("/candidate-profile/"))) {
    const sliced = path.split('/');
    const id = sliced[sliced.length - 1];

    if (regexUUID.test(id)) {
      return route(`/candidate-profile/${id}`);
    }
  }

  if (path === route("/job")) {
    return route("/job");
  }

  if (path === route("/job-applications")) {
    return route("/job-applications");
  }

  if (path.includes(route("/job/"))) {
    return route("/job");
  }

  if (path.includes(route("/job-applications/"))) {
    let sliced = path.split('/');
    const id = sliced[sliced.length - 1];

    if (regexUUID.test(id)) {
      return route(`/job-applications/${id}`);
    }

    return route("/job-applications");
  }

  return '';
};

const GetBreadCrumb = (
  location: Location<any>,
  companyName: string | null,
  clientName: string | null,
  candidateName?: string | null,
  stageName?: string | null
): { label: string; path: string; state?: any }[] => {
  const path = location.pathname;
  const userName = location.state?.userName;
  const jobName = location.state?.jobName;

  if (path.includes(route("/profile"))) {
    if (path.includes('update-password')) {
      return [
        { label: 'Profile', path: route("/profile") },
        { label: 'Update Password', path: route("/profile/update-password") },
      ];
    }

    return [{ label: 'Profile', path: route("/profile") }];
  }

  if (path === route("/dashboard")) {
    return [{ label: 'Dashboard', path: route("/dashboard") }];
  }

  if (path === route("/site-recommendations")) {
    return [{ label: 'Recommendations', path: route("/site-recommendations") }];
  }

  if (path === route("/company") || 
      path === route("/company/clients") || 
      path === route("/company/users") || 
      path === route("/company/candidates")) {
    return [{ label: companyName || 'Company', path: route("/company") }];
  }

  if (path === route("/client-profile")) {
    return [
      { label: companyName || 'Company', path: route("/company") },
      { label: 'Clients', path: route("/company/clients") },
      { label: 'New Client', path: route("/client-profile") }
    ];
  }

  if (path.includes(route("/client-profile/"))) {
    const sliced = path.split('/');
    const id = sliced[sliced.length - 1];

    if (regexUUID.test(id)) {
      return [
        { label: companyName || 'Company', path: route("/company") },
        { label: 'Clients', path: route("/company/clients") },
        { label: clientName || 'Client Profile', path: route(`/client-profile/${id}`), state: { clientName } }
      ];
    }
  }

  if (path === route("/stage-screen")) {
    return [
      { label: companyName || 'Company', path: route("/company") },
      { label: 'Client Profile', path: route("/client-profile") },
      { label: 'New Stage', path: route("/stage-screen") },
    ];
  }

  if (path.includes(route("/stage-screen/"))) {
    const sliced = path.split('/');
    const last = sliced[sliced.length - 1];
    const secondLast = sliced[sliced.length - 2];

    if (regexUUID.test(last) && regexUUID.test(secondLast)) {
      return [
        { label: companyName || 'Company', path: route("/company") },
        { label: 'Clients', path: route("/company/clients") },
        { label: clientName || 'Client Profile', path: route(`/client-profile/${secondLast}`), state: { clientName } },
        { label: 'Stages', path: route(`/client-profile/${secondLast}`), state: { clientName, activeTab: '2' } },
        { label: truncateText(stageName, { defaultText: 'Stage' }), path: route(`/stage-screen/${secondLast}/${last}`), state: { clientName, stageName } },
      ];
    }

    if (regexUUID.test(last)) {
      return [
        { label: companyName || 'Company', path: route("/company") },
        { label: 'Clients', path: route("/company/clients") },
        { label: clientName || 'Client Profile', path: route(`/client-profile/${last}`), state: { clientName } },
        { label: 'Stages', path: route(`/client-profile/${last}`), state: { clientName, activeTab: '2' } },
        { label: 'New Stage', path: route(`/stage-screen/${last}`) },
      ];
    }
  }

  if (path === route("/users")) {
    return [{ label: companyName || 'Company', path: route("/company") }];
  }

  if (path === route("/user-profile")) {
    return [
      { label: companyName || 'Company', path: route("/company") },
      { label: 'Users', path: route("/company/users") },
      { label: 'New User', path: route("/user-profile") }
    ];
  }

  if (path.includes(route("/user-profile/"))) {
    const sliced = path.split('/');
    const id = sliced[sliced.length - 1];

    if (regexUUID.test(id)) {
      return [
        { label: companyName || 'Company', path: route("/company") },
        { label: 'Users', path: route("/company/users") },
        { label: userName || 'User Profile', path: route(`/user-profile/${id}`), state: { userName } }
      ];
    }
  }

  if (path === route("/candidates")) {
    return [{ label: companyName || 'Company', path: route("/company") }];
  }

  if (path === route("/candidate-match")) {
    return [{ label: 'Candidate Match', path: route("/candidate-match") }];
  }

  if (path === route("/candidate-profile")) {
    return [
      { label: companyName || 'Company', path: route("/company") },
      { label: 'Candidates', path: route("/company/candidates") },
      { label: 'New Candidate', path: route("/candidate-profile") }
    ];
  }

  if (path.includes(route("/candidate-profile/"))) {
    const sliced = path.split('/');
    const id = sliced[sliced.length - 1];

    if (regexUUID.test(id)) {
      if (location.state?.fromCandidateMatch) {
        return [
          { label: 'Candidate Match', path: route("/candidate-match") },
          { label: candidateName || 'Candidate Profile', path: route(`/candidate-profile/${id}`), state: { candidateName, fromCandidateMatch: true } }
        ];
      }

      if (location.state?.fromJobApplication && location.state?.jobApplicationId) {
        if (location.state?.fromDashboard) {
          return [
            { label: 'Dashboard', path: route("/dashboard") },
            { label: 'Job Application', path: route(`/job-applications/${location.state.jobApplicationId}`), state: { jobName, candidateName, fromDashboard: true } },
            { label: candidateName || 'Candidate Profile', path: route(`/candidate-profile/${id}`), state: { candidateName, jobName, fromJobApplication: true, jobApplicationId: location.state.jobApplicationId, fromDashboard: true } }
          ];
        }
        
        return [
          { label: 'Job Applications', path: route("/job-applications") },
          { label: 'Job Application', path: route(`/job-applications/${location.state.jobApplicationId}`), state: { jobName, candidateName } },
          { label: candidateName || 'Candidate Profile', path: route(`/candidate-profile/${id}`), state: { candidateName, jobName, fromJobApplication: true, jobApplicationId: location.state.jobApplicationId } }
        ];
      }
      
      if (location.state?.fromRecommendations && location.state?.jobId) {
        return [
          { label: 'Jobs', path: route("/job") },
          { label: location.state?.jobName || 'Job', path: route(`/job/${location.state.jobId}`), state: { jobName: location.state?.jobName } },
          { label: 'Recommendations', path: route(`/job/${location.state.jobId}`), state: { activeTab: 'recommendations', jobName: location.state?.jobName } },
          { label: candidateName || 'Candidate Profile', path: route(`/candidate-profile/${id}`), state: { candidateName, fromRecommendations: true, jobId: location.state.jobId, jobName: location.state?.jobName } }
        ];
      }
      
      return [
        { label: companyName || 'Company', path: route("/company") },
        { label: 'Candidates', path: route("/company/candidates") },
        { label: candidateName || 'Candidate Profile', path: route(`/candidate-profile/${id}`), state: { candidateName } }
      ];
    }
  }

  if (path === route("/job")) {
    return [{ label: 'Jobs', path: route("/job") }];
  }

  if (path === route("/job-applications")) {
    return [{ label: 'Job Applications', path: route("/job-applications") }];
  }

  if (path.includes(route("/job/"))) {
    let sliced = path.split('/');

    if (!path.includes('preview') && !path.includes('job-applications')) {
      const id = sliced[sliced.length - 1];

      if (regexUUID.test(id)) {
        if (location.state?.fromDashboard) {
          return [
            { label: 'Dashboard', path: route("/dashboard") },
            { label: jobName || 'Job', path: route(`/job/${id}`), state: { jobName, fromDashboard: true } },
          ];
        }
        
        return [
          { label: 'Jobs', path: route("/job") },
          { label: jobName || 'Job', path: route(`/job/${id}`), state: { jobName } },
        ];
      }

      if (location.state?.fromDashboard) {
        return [
          { label: 'Dashboard', path: route("/dashboard") },
          { label: 'New Job', path: route("/job/create") },
        ];
      }
      
      return [
        { label: 'Jobs', path: route("/job") },
        { label: 'New Job', path: route("/job/create") },
      ];
    }

    const id = sliced[sliced.length - 2];

    if (path.includes('preview')) {
      return [
        { label: 'Jobs', path: route("/job") },
        { label: jobName || 'Job', path: route(`/job/${id}`), state: { jobName } },
        { label: 'Preview', path: route(`/job/${id}/preview`) },
      ];
    }

    return [
      { label: location.state?.fromDashboard ? 'Dashboard' : 'Jobs', path: location.state?.fromDashboard ? route("/dashboard") : route("/job") },
      { label: jobName || 'Job', path: route(`/job/${id}`), state: { jobName, ...(location.state?.fromDashboard ? { fromDashboard: true } : {}) } },
      { label: 'Job Applications', path: route(`/job/${id}/job-applications`), state: { jobName, fromJobApplicationsByJob: true, jobId: id } },
    ];
  }

  if (path.includes(route("/job-applications/"))) {
    let sliced = path.split('/');
    const id = sliced[sliced.length - 1];

    if (regexUUID.test(id)) {
      const breadcrumbLabel = jobName && candidateName 
        ? `${jobName} - ${candidateName}` 
        : 'Job Application';
      
      if (location.state?.fromJobApplicationsByJob && location.state?.jobId) {
        if (location.state?.fromDashboard) {
          return [
            { label: 'Dashboard', path: route("/dashboard") },
            { label: truncateText(jobName, { defaultText: 'Job', xsLimit: 20, sLimit: 1000 }) || 'Job', path: route(`/job/${location.state.jobId}`) },
            { label: 'Job Applications', path: route(`/job/${location.state.jobId}/job-applications`) },
            { label: truncateText(candidateName, { defaultText: 'Job Application' }) || 'Job Application', path: route(`/job-applications/${id}`), state: { jobName, candidateName, fromJobApplicationsByJob: true, jobId: location.state.jobId, fromDashboard: true } },
          ];
        }
        
        return [
          { label: 'Jobs', path: route("/job") },
          { label: truncateText(jobName, { defaultText: 'Job', xsLimit: 20, sLimit: 1000 }) || 'Job', path: route(`/job/${location.state.jobId}`) },
          { label: 'Job Applications', path: route(`/job/${location.state.jobId}/job-applications`) },
          { label: truncateText(candidateName, { defaultText: 'Job Application' }) || 'Job Application', path: route(`/job-applications/${id}`), state: { jobName, candidateName, fromJobApplicationsByJob: true, jobId: location.state.jobId } },
        ];
      }
      
      if (location.state?.fromJobApplicationsTable) {
        return [
          { label: 'Job Applications', path: route("/job-applications") },
          { label: breadcrumbLabel, path: route(`/job-applications/${id}`), state: { jobName, candidateName, fromJobApplicationsTable: true } },
        ];
      }
      
      if (location.state?.fromDashboard) {
        return [
          { label: 'Dashboard', path: route("/dashboard") },
          { label: breadcrumbLabel, path: route(`/job-applications/${id}`), state: { jobName, candidateName, fromDashboard: true } },
        ];
      }
      
      return [
        { label: 'Job Applications', path: route("/job-applications") },
        { label: breadcrumbLabel, path: route(`/job-applications/${id}`), state: { jobName, candidateName } },
      ];
    }
  }

  if (path === route("/clients")) {
    return [{ label: companyName || 'Company', path: route("/company") }];
  }

  if (path === route("/users")) {
    return [{ label: companyName || 'Company', path: route("/company") }];
  }

  if (path === route("/candidates")) {
    return [{ label: companyName || 'Company', path: route("/company") }];
  }

  return [{ label: 'Dashboard', path: route("/dashboard") }];
};

export { GetSelected, GetBreadCrumb };
